/**
 * Holi gift tags — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_shivratri_holi`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const holiGiftTagsPack: ToilePack = {
    slug: 'holi-gift-tags',
    category: 'faith',
    name: 'Holi gift tags',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'splash', label: 'Colour splash', subject: 'a sheet of six rectangular tags with a punched hole, each with a splash of gulal, "Happy Holi" lettered and a blank line for a name'},
        {key: 'gujiya', label: 'Sweets box', subject: 'a sheet of six round tags with a small gujiya drawing, "Holi Treats" lettered and a blank line for a name'},
        {key: 'thankyou', label: 'Thank you', subject: 'a sheet of six scalloped tags with a pichkari motif, "Thank You for Coming" lettered and a blank line underneath'},
    ],
    styles: [
        {key: 'gulal', label: 'Gulal splash', style: 'bold flat vector tags with powder-burst shapes and clean edges', palette: 'magenta, saffron, green and blue on white', framing: 'tags in an even grid on a white page with a margin'},
        {key: 'kraft', label: 'Kraft paper', style: 'stamped print look with rough ink texture on brown kraft paper', palette: 'two-colour ink of red and indigo on kraft brown', framing: 'tags in an even grid on a kraft page with a margin'},
        {key: 'boho', label: 'Boho floral', style: 'delicate hand-drawn marigold and mango-leaf line motifs with soft flat colour', palette: 'marigold orange, leaf green and rose on ivory', framing: 'tags in an even grid on an ivory page with a margin'},
    ],
    directions: ['for sweets box', 'return gifts', 'gold border'],
    directionHint: 'try: for sweets box',
    seo: {
        title: 'Holi gift tags: colour splash, sweets box, thank you',
        metaDescription: 'Nine printable Holi gift tag sheets with a punched hole and a blank name line, for sweets, herbal gulal and party return gifts, in three styles.',
        h1: 'Holi gift tags: colour splash, sweets box and thank you for coming',
        tagline: 'Nine tags on sheets of six, three designs in three finishes each, with a blank line for a name.',
        intro: 'Tags to print, cut out and tie to a box of gujiya, a pack of herbal gulal or a return gift for party guests. Each sheet lays out six tags, each with a punched hole and a blank line for a name. The tags read Happy Holi over a splash of gulal, Holi Treats beside a gujiya, or Thank You for Coming beside a pichkari. Type a different use and the same layouts carry it.',
        useCases: [
            'A tag on a box of sweets for family',
            'A return gift tag for party guests',
            'A label on a pack of herbal gulal',
            'A name tag for a school or office gift',
        ],
        faq: [
            {q: 'How many tags are on a sheet?', a: 'Each sheet lays out six tags.'},
            {q: 'Do the tags have a hole to tie them?', a: 'Yes. Each tag has a punched hole at the top for string or ribbon.'},
            {q: 'Can I add a name?', a: 'Each tag has a blank line for a name, which you write or print in afterwards.'},
        ],
    },
}
